import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { settingsPath, SettingsSection } from '../app/routes';
import { useExportReminder } from '../hooks/useExportReminder';
import { ReminderKind } from '../lib/exportReminder';
import styles from './TopBar.module.css';

/** A small, non-blocking hint in the top bar when a backup export is overdue; it opens Settings → Data. */
export function ExportHint() {
  const { t } = useTranslation();
  const { reminder, localMode } = useExportReminder();
  if (reminder === null) return null;
  const stale = reminder.kind === ReminderKind.Stale;
  const text = t(`data.reminder.${localMode ? (stale ? 'localStale' : 'localNever') : stale ? 'stale' : 'never'}`, {
    days: reminder.days,
  });
  return (
    <Link
      to={settingsPath(SettingsSection.Data)}
      className={styles.exportHint}
      title={text}
      data-testid="export-hint"
    >
      {t('data.reminder.hint')}
    </Link>
  );
}
